export const withModeBarConfig: Partial<Plotly.Config> = {
    displayModeBar: true,
    modeBarButtons: [['toImage','zoom3d', 'pan2d', 'orbitRotation', 'tableRotation', 'resetCameraLastSave3d']],
    displaylogo: false,
};

export const modeBarDisabled: Partial<Plotly.Config> = {
    displayModeBar: false,
}
